
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"24","height":"24","viewBox":"0 0 24 24","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.99805 18H19.998","stroke":"#10001F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.99805 12H19.998","stroke":"#10001F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M9.99805 6H19.998","stroke":"#10001F","stroke-width":"2","stroke-linecap":"round","stroke-linejoin":"round"}}),_c('path',{attrs:{"d":"M3.51367 6.06V4.5H6.05617V9.9825H4.30867V6.06H3.51367Z","fill":"#10001F"}}),_c('path',{attrs:{"d":"M3.12211 18.275C3.79211 17.775 4.32211 17.3225 4.71211 16.9175C5.10211 16.5075 5.29711 16.125 5.29711 15.77C5.29711 15.65 5.26961 15.5575 5.21461 15.4925C5.16461 15.4275 5.09711 15.395 5.01211 15.395C4.91211 15.395 4.83211 15.4475 4.77211 15.5525C4.71711 15.6525 4.69711 15.8075 4.71211 16.0175H3.09961C3.11461 15.5525 3.21461 15.17 3.39961 14.87C3.58961 14.57 3.83461 14.35 4.13461 14.21C4.43461 14.07 4.76461 14 5.12461 14C5.76461 14 6.23211 14.155 6.52711 14.465C6.82711 14.77 6.97711 15.1625 6.97711 15.6425C6.97711 16.1475 6.81461 16.6225 6.48961 17.0675C6.16961 17.5075 5.76711 17.88 5.28211 18.185H6.99961V19.5275H3.12211V18.275Z","fill":"#10001F"}})])
          )
        }
      }
    